<template>
  <div v-if="mode" @click="chuli()" class="lee-switch" :class="[size,{check:value,mod:mode}]">
    <i>
      <svg viewBox="0 0 24 24" class="light-icon" data-v-3de418c2="">
        <path
            d="M6.05 4.14l-.39-.39a.993.993 0 0 0-1.4 0l-.01.01a.984.984 0 0 0 0 1.4l.39.39c.39.39 1.01.39 1.4 0l.01-.01a.984.984 0 0 0 0-1.4zM3.01 10.5H1.99c-.55 0-.99.44-.99.99v.01c0 .55.44.99.99.99H3c.56.01 1-.43 1-.98v-.01c0-.56-.44-1-.99-1zm9-9.95H12c-.56 0-1 .44-1 .99v.96c0 .55.44.99.99.99H12c.56.01 1-.43 1-.98v-.97c0-.55-.44-.99-.99-.99zm7.74 3.21c-.39-.39-1.02-.39-1.41-.01l-.39.39a.984.984 0 0 0 0 1.4l.01.01c.39.39 1.02.39 1.4 0l.39-.39a.984.984 0 0 0 0-1.4zm-1.81 15.1l.39.39a.996.996 0 1 0 1.41-1.41l-.39-.39a.993.993 0 0 0-1.4 0c-.4.4-.4 1.02-.01 1.41zM20 11.49v.01c0 .55.44.99.99.99H22c.55 0 .99-.44.99-.99v-.01c0-.55-.44-.99-.99-.99h-1.01c-.55 0-.99.44-.99.99zM12 5.5c-3.31 0-6 2.69-6 6s2.69 6 6 6s6-2.69 6-6s-2.69-6-6-6zm-.01 16.95H12c.55 0 .99-.44.99-.99v-.96c0-.55-.44-.99-.99-.99h-.01c-.55 0-.99.44-.99.99v.96c0 .55.44.99.99.99zm-7.74-3.21c.39.39 1.02.39 1.41 0l.39-.39a.993.993 0 0 0 0-1.4l-.01-.01a.996.996 0 0 0-1.41 0l-.39.39c-.38.4-.38 1.02.01 1.41z"
            fill="currentColor"></path>
      </svg>
      <svg viewBox="0 0 24 24" class="dark-icon" data-v-3de418c2="">
        <path
            d="M11.01 3.05C6.51 3.54 3 7.36 3 12a9 9 0 0 0 9 9c4.63 0 8.45-3.5 8.95-8c.09-.79-.78-1.42-1.54-.95A5.403 5.403 0 0 1 11.1 7.5c0-1.06.31-2.06.84-2.89c.45-.67-.04-1.63-.93-1.56z"
            fill="currentColor"></path>
      </svg>
    </i>
  </div>
  <div v-else @click="chuli()" class="lee-switch" :class="[size,{check:value}]" :style="'color:'+color"
       :start-text="startText"
       :end-text="endText"></div>

</template>
<script>
export default {
    name: 'LeeSwitch',
    inheritAttrs: false,
    data() {
        return {};
    },
    mounted() {
        if (this.value === false) {
            if (this.mode) {
                if (this.getItem('mode')) {
                    this.$emit('input', true)
                    this.setItem('mode', 1, 1)
                    document.documentElement.classList.add('dark')
                } else {
                    this.$emit('input', false)
                    this.removeItem('mode')
                    document.documentElement.classList.remove('dark')
                }
            }

        } else {
            if (this.mode) {
                if (!this.getItem('mode')) {
                    this.$emit('input', false)
                    this.removeItem('mode')
                    document.documentElement.classList.remove('dark')
                } else {
                    this.$emit('input', true)
                    this.setItem('mode', 1, 1)
                    document.documentElement.classList.add('dark')
                }

            }
        }
        // if (this.getItem('mode')) {
        //     this.$emit('input', true)
        //     if (this.mode) {
        //         document.documentElement.classList.add('dark')
        //     }
        // } else {
        //     this.$emit('input', false)
        //     if (this.mode) {
        //         document.documentElement.classList.remove('dark')
        //     }
        // }
    },
    methods: {
        chuli() {
            if (this.value === false) {
                this.$emit('input', true)
                if (this.mode) {
                    this.setItem('mode', 1, 1)
                    document.documentElement.classList.add('dark')
                }
            } else {
                this.$emit('input', false)
                if (this.mode) {
                    this.removeItem('mode')
                    document.documentElement.classList.remove('dark')
                }
            }
        },
        setItem(key, data, time) {
            try {
                if (!localStorage) {
                    return false;
                }
                var cacheExpireDate = new Date().getTime() + time * 60 * 60 * 24 * 1000;
                var cacheVal = {val: data, exp: cacheExpireDate};
                localStorage.setItem(key, JSON.stringify(cacheVal)); //存入缓存值
            } catch (e) {
                console.log(e)
            }
        },
        getItem(key) {
            try {
                if (!localStorage) {
                    return false;
                }
                var cacheVal = localStorage.getItem(key);
                var result = JSON.parse(cacheVal);
                var now = new Date().getTime();
                //缓存不存在
                if (!result) {
                    return null;
                }
                //缓存过期
                if (now > result.exp) {
                    this.removeItem(key);
                    return "";
                }
                return result.val;
            } catch (e) {
                this.removeItem(key);
                return null;
            }
        },
        removeItem(key) {
            if (!localStorage) {
                return false;
            }
            localStorage.removeItem(key);
        }
    },
    props: {
        mode: {
            type: Boolean,
            default: false //false
        },
        value: {
            type: Boolean,
            default: false //false
        },
        color: {
            type: String,
            default: '#46bd87' //#46bd87
        },
        size: {
            type: String,
            default: 's' //s
        },
        startText: {
            type: String,
            default: '开' //s
        },
        endText: {
            type: String,
            default: '关' //s
        },
    }
};
</script>
<style scoped>
.lee-switch {
  background: #f2f2f2;
  cursor: pointer;
  position: relative;
  transition: all .3s;
  display: flex;
  align-items: center;

}

.lee-switch.mod {
  box-shadow: inset 0 0 0px 1px #dfe2e5;
}

.lee-switch.check {
  background: currentColor;
}

.lee-switch.mod.check {
  background: #f2f2f2;
}

.lee-switch:before, .lee-switch i {
  background: #fff;
  border-radius: 100%;
  position: absolute;
  content: '';
  left: 2px;
  top: 2px;
  transition: all .3s
}

.lee-switch i {
  display: flex;
  align-items: center;
  justify-content: center;
}

.lee-switch i svg {
  position: absolute;
  width: 80%;
  height: 80%;
  transition: all .1s;
}

.lee-switch i svg.dark-icon {
  opacity: 0;
}

.lee-switch i svg.light-icon {
  opacity: 1;
}

.lee-switch.check i svg.dark-icon {
  opacity: 1;
}

.lee-switch.check i svg.light-icon {
  opacity: 0;
}


.lee-switch.s {
  width: 40px;
  height: 20px;
  border-radius: 10px;
}

.lee-switch.s:before {
  width: 16px;
  height: 16px;
}

.lee-switch.s i {
  width: 16px;
  height: 16px;
}

.lee-switch.s.check:before, .lee-switch.s.check i {
  left: calc(100% - 18px)
}

.lee-switch.m {
  width: 62px;
  height: 26px;
  border-radius: 13px;
}

.lee-switch.m:before, .lee-switch.m i {
  width: 22px;
  height: 22px;
}

.lee-switch.m.check:before, .lee-switch.m.check i {
  left: calc(100% - 24px)
}

.lee-switch.l {
  width: 92px;
  height: 36px;
  border-radius: 18px;
}

.lee-switch.l:before, .lee-switch.l i {
  width: 32px;
  height: 32px;
}

.lee-switch.l.check:before, .lee-switch.l.check i {
  left: calc(100% - 34px)
}

.lee-switch:after {
  content: attr(end-text);
  position: absolute;
  transition: all .4s;
}

.lee-switch.check:after {
  content: attr(start-text);
  color: #fff;
}

.lee-switch.mod:before, .lee-switch.mod:after {
  content: none;
}

.lee-switch.s:after {
  font-size: 12px;
}

.lee-switch.s:after {
  left: calc(100% - 20px)
}

.lee-switch.s.check:after {
  left: 6px
}

.lee-switch.m:after {
  font-size: 14px;
}

.lee-switch.m:after {
  left: calc(100% - 22px)
}

.lee-switch.m.check:after {
  left: 6px
}

.lee-switch.l:after {
  font-size: 16px;
}

.lee-switch.l:after {
  left: calc(100% - 28px)
}

.lee-switch.l.check:after {
  left: 12px
}
</style>



// WEBPACK FOOTER //
// node_modules/leevueplugin/src/LeeSwitch.vue